import React from "react";

import { IconButton, InputAdornment, TextField } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

import { useCalendarDateTime } from "./useCalendarDateTime";
import CalendarDateTimeDialog from "./CalendarDateTimeDialog";
import { CalendarIcon } from "@components/Icons";

export interface CalendarDateTimeProps {
  title: string;
  value?: string | null; // ISO
  onChange: (value: string | null) => void;
  disabled?: boolean;
  placeholder?: string;
  errorText?: string | false;
  minDate?: Date | null;
  sx?: SxProps<Theme>;
}

const CalendarDateTime: React.FC<CalendarDateTimeProps> = ({
  title,
  value,
  onChange,
  disabled,
  placeholder,
  errorText,
  minDate,
  sx,
}) => {
  const {
    state: { open, selectedTime, daysMatrix, selectedDateLabel, displayText },

    // ações
    actions: {
      openDialog,
      closeDialog,
      handleMonthChange,
      handleDayClick,
      handleTimeClick,
      handleClear,
      handleConfirm,
    },
  } = useCalendarDateTime({ value, onChange });

  return (
    <>
      <TextField
        fullWidth
        disabled={disabled}
        placeholder={placeholder}
        value={displayText}
        onClick={() => !disabled && openDialog()}
        onChange={() => {}}
        error={!!errorText}
        helperText={errorText}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton edge="end" onClick={openDialog}>
                <CalendarIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={sx}
      />

      <CalendarDateTimeDialog
        open={open}
        title={title}
        daysMatrix={daysMatrix}
        selectedDateLabel={selectedDateLabel}
        selectedTime={selectedTime}
        onMonthChange={handleMonthChange}
        onDayClick={handleDayClick}
        onTimeClick={handleTimeClick}
        onClear={handleClear}
        onClose={closeDialog}
        onConfirm={handleConfirm}
        minDate={minDate ?? undefined}
      />
    </>
  );
};

export default CalendarDateTime;
